import React from 'react';

function RBCelections() {
  return (
    <div>
      <h1>Regional Bahá’í Council Elections</h1>
      <br />
      <h3>Letters from the National Spiritual Assembly</h3>
      <ul className="plain-list">
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/20250716+All+LSAs+-+2025+Casting+of+Ballots+for+Regional+Bah%C3%A1%E2%80%99%C3%AD+Councils.pdf">
            Casting of Ballots for Regional Bahá’í Councils (English) (PDF)
          </a>
        </li>
        <li>
          <strong>Download All LSAs - NSA on participation in RBC balloting process:</strong>{' '}
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/20250915+All+LSAs+-+NSA+on+participation+in+RBC+balloting+process+(English).pdf">
            English (PDF)
          </a>{' '}
          |{' '}
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/20250915+All+LSAs+-+NSA+on+participation+in+RBC+balloting+process+(Persian).pdf">
            Persian (PDF)
          </a>{' '}
          |{' '}
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/20250915+All+LSAs+-+NSA+on+participation+in+RBC+balloting+process+(Spanish).pdf">
            Spanish (PDF)
          </a>
        </li>
      </ul>
      <hr />
      <h3>Ballots</h3>
      <ul className="plain-list">
        <p>
          <b>9-Member Councils:</b>
          <br />
          <b>Atlantic:</b> Delaware, District of Columbia, Maryland, North Carolina, Virginia
          <br />
          <b>California</b>
          <br />
          <b>Four Corners:</b> Arizona, Colorado, Nevada, New Mexico, Utah
          <br />
          <b>Northeast:</b> Connecticut, Maine, Massachusetts, New Hampshire, New Jersey, New York, Pennsylvania, Rhode Island,
          Vermont
          <br />
          <b>Northwest:</b> Oregon, Washington
          <br />
          <b>Prairie States:</b> Iowa, Kansas, Missouri, Nebraska
          <br />
          <b>South Central:</b> Arkansas, Louisiana, Oklahoma, Texas
          <br />
          <b>Southeast:</b> Alabama, Georgia, Mississippi, South Carolina
        </p>
        <li>
          <strong>Download 9-member ballot: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2022/Ballot-For-Councils-with-9-members-(English).pdf">
            English (PDF)
          </a>{' '}
          |{' '}
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2022/Ballot-For-Councils-with-9-members-(Persian).pdf">
            Persian (PDF)
          </a>
        </li>
        <br />
        <p>
          <b>7-Member Councils:</b>
          <br />
          <b>Appalachia:</b> Kentucky, Tennessee, West Virginia
          <br />
          <b>Florida</b>
          <br />
          <b>Heartland:</b> Illinois, Minnesota, Wisconsin
          <br />
          <b>Midwest:</b> Indiana, Michigan, Ohio
        </p>
        <li>
          <strong>Download 7-member ballot: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2022/Ballot-For-Councils-with-7-members-(English).pdf">
            English (PDF)
          </a>{' '}
          |{' '}
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2022/Ballot-For-Councils-with-7-members-(Persian).pdf">
            Persian (PDF)
          </a>
        </li>
        <br />
        <p>
          <b>5-Member Council:</b>
          <br />
          <b>Northern Plains:</b> Idaho, Montana, North Dakota, South Dakota, Wyoming
        </p>
        <li>
          <strong>Download 5-member ballot: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2022/Ballot-For-Councils-with-5-members-(English).pdf">
            English (PDF)
          </a>{' '}
          |{' '}
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2022/Ballot-For-Councils-with-5-members-(Persian).pdf">
            Persian (PDF)
          </a>
        </li>
      </ul>
      <hr />
      <h3>Voter Instructions</h3>
      <ul className="plain-list">
        <li>
          <strong>Download Voter Instructions: </strong>
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/2025+RBC+Election+Voting+Instructions+(English).pdf">
            English (PDF)
          </a>{' '}
          |{' '}
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/2025+RBC+Election+Voting+Instructions+(Persian).pdf">
            Persian (PDF)
          </a>{' '}
          |{' '}
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/2025+RBC+Election+Voting+Instructions+(Spanish).pdf">
            Spanish (PDF)
          </a>
        </li>
      </ul>
      <hr />
      <h3>Election Call Letters</h3>
      <p>
        <strong>Download:</strong>{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+AP+-+2025+Election+Call+Letter.pdf">
          Appalachia (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+AT+-+2025+Election+Call+Letter.pdf">
          Atlantic (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+CA+-+2025+Election+Call+letter.pdf">
          California (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+FL+-+2025+Election+Call+Letter.pdf">
          Florida (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+FC+-+2025+Election+Call+Letter.pdf">
          Four Corners (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+HL+-+2025+Election+Call+Letter.pdf">
          Heartland (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+MW+-+2025+Election+Call+letter.pdf">
          Midwest (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+NE+-+2025+Election+Call+letter.pdf">
          Northeast (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+NP+-+2025+Election+Call+letter.pdf">
          Northern Plains (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+NW+-+2025+Election+Call+letter.pdf">
          Northwest (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+PS+-+2025+Election+Call+letter.pdf">
          Prairie States (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+SE+-+2025+Election+Call+letter.pdf">
          Southeast (PDF)
        </a>{' '}
        |{' '}
        <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/RBC+SC+-+2025+Election+Call+letter.pdf">
          South Central (PDF)
        </a>
      </p>
      <hr />
      <h3>Guidance</h3>
      <ul className="plain-list">
        <li>
          <strong>Download: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2022/2022-Compilation-of-Guidance-The-Nature-of-Bahai-Elections-(English).pdf">
            Compilation of Guidance on the Nature of Bahá’í Elections (English) (PDF)
          </a>
        </li>
        <li>
          <strong>Download Compilation of Guidance on the Functions of RBCs: </strong>
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2022/2022-Compilation-of-Guidance-Functions-of-RBCs-(English).pdf">
            English (PDF)
          </a>{' '}
          |{' '}
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2022/2022-Compilation-of-Guidance-Functions-of-RBCs-(Persian).pdf">
            Persian (PDF)
          </a>{' '}
          |{' '}
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2022/2022-Compilation-of-Guidance-Functions-of-RBCs-(Spanish).pdf">
            Spanish (PDF)
          </a>
        </li>
      </ul>
      <hr />
      <h3 id="RBCbyElections">Reporting By-elections</h3>
      <ul className="plain-list">
        <li>
          <strong>Download:</strong>{' '}
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/20250909+All+LSAs+-+Reporting+by-elections.pdf">
            Letter from the NSA to all LSAs about reporting by-elections (PDF)
          </a>
        </li>
        <li>
          <strong>Download:</strong>{' '}
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/Attachment+1+-+Instructions+on+reporting+by-elections.pdf">
            Reporting By-elections of Local Spiritual Assemblies <em>updated September 2025</em> (English) (PDF)
          </a>
        </li>
        <li>
          <strong>Download:</strong>{' '}
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2024/By-Election+form.pdf">
            By-election form (English) (PDF)
          </a>
        </li>
      </ul>
      <hr />
      <h3>National Spiritual Assembly’s announcement of the first elections for the Regional Bahá’í Councils</h3>
      <ul className="plain-list">
        <li>
          These new institutions, assigned to the four regions designated by ‘Abdu’l-Bahá in the Tablets of the Divine Plan, will
          serve as powerful instruments for diffusing the spirit of the Faith and “catering to the requirements of spiritual
          relationships which flow from love and unity among the friends.”
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://s3.amazonaws.com/bahai-web/tab/regions/11231997-nsa-on-election.pdf">Letter (English) (PDF)</a>
        </li>
      </ul>
      <hr />
      <h3>Universal House of Justice message calling into being the Regional Councils</h3>
      <ul className="plain-list">
        <li>
          The expansion of the Bahá’í community and the growing complexity of the issues which are facing National Spiritual
          Assemblies in certain countries have brought the Cause to a new stage in its development. They have caused us in recent
          years to examine various aspects of the balance between centralization and decentralization.
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://s3.amazonaws.com/bahai-web/tab/regions/05301997-uhj-on-regions.pdf">Letter (English) (PDF)</a>
        </li>
      </ul>
      <hr />
      <h3>Characteristics and functions of Regional Bahá’í Councils</h3>
      <ul className="plain-list">
        <li>
          Regional Bahá’í Councils are not necessarily established universally throughout a country, but rather in those regions
          where the condition and size of the Bahá’í community indicate that such a development would be beneficial.
        </li>
        <li>
          <strong>Download: </strong>
          <a href="https://s3.amazonaws.com/bahai-web/tab/regions/05301997-uhj-regional-characteristics.pdf">
            Letter (English) (PDF)
          </a>
        </li>
      </ul>
    </div>
  );
}

export default RBCelections;
